/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import store from './store'
import BuyModalComponent from '@/components/shared/buyModal'
import 'vuetify/dist/vuetify.min.css'
import firebase from 'firebase'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.component('app-buy-modal', BuyModalComponent)
Vue.config.productionTip = false
Vue.use(Vuetify)

const firebaseConfig = {
  apiKey: "AIzaSyDe_TV1FQuVI69a9KAO4h-zFyPSjZJ_9Do",
  authDomain: "itc-ads-2ca79.firebaseapp.com",
  projectId: "itc-ads-2ca79",
  storageBucket: "itc-ads-2ca79.appspot.com",
  messagingSenderId: "163858522285",
  appId: "1:163858522285:web:695bbae9caf0afbacf2624",
  measurementId: "G-HFN4RZ6BN5"
};


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  Vuetify,
  store,
  components: { App },
  template: '<App/>',
  created () {
    firebase.initializeApp(firebaseConfig)
    firebase.auth().onAuthStateChanged(user => {
      if(user) {
         this.$store.dispatch('autoLoginUser', user)
       }
})
  this.$store.dispatch('fetchAds')
  }
})




// WEBPACK FOOTER //
// ./src/main.js